import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

function InviteTimeHeader() {
  return (
    <>
      <p className="text-lg font-semibold mt-4">
        <T kind="When should we send it?" />
      </p>
      <p className="text-sm">
        <T kind="Set the time and date to send participants invitations for this collection" />
      </p>
    </>
  );
}

export default observer(InviteTimeHeader);
